module.exports = __webpack_public_path__ + "732c2b397511b291abeb188dec746a38.svg";